export default __webpack_public_path__ + "c7c3ed3de301d49b6f852d7b485191de.svg";